import React from "react";
import {DEFAULT_HALL, IS_DEV, ROOT_STORAGE_WEB} from "helpers/config";
import {useTypedSelector} from "helpers/reducers";
import {Hall} from "types/entities/Hall";
import {HallCode} from "types/enums/HallCode";
import {RouteComponentProps, withRouter} from "react-router-dom";

interface FooterLogoProps extends RouteComponentProps {}

const FooterLogo = (props: FooterLogoProps) => {
    const hall = useTypedSelector<Hall | null>(state => state.hallState.hall) || null;
    const location = props.location.pathname;
    const homeUrl = hall && location.includes("/booking") ? (DEFAULT_HALL === HallCode.ArboPark ? "https://" + hall.domain : "https://" + hall.app_url) : "/";

    return (
        <div className={"container mx-auto flex flex-row items-center justify-center z-10 border-b border-[#c0bcbc] md:border-b-0 pb-10 md:pb-0 mb-8 md:mb-20"}>
            <div className={"FooterLogo mx-auto"}>
                <a aria-current="page" href={homeUrl}>
                    <img
                        alt={hall ? hall.name : "Logo"}
                        className={"object-contain mx-auto w-[300px] sm:w-auto h-[100px]"}
                        src={hall ? (IS_DEV ? hall.image.replace("/img/", ROOT_STORAGE_WEB + "/img/") : hall.image) : ""}
                    />
                </a>
            </div>
        </div>
    );
};

export default withRouter(FooterLogo);
